<template>
  <ValidationObserver ref="customerForm" v-slot="{ invalid, passes }">
    <v-form rel="customerForm" @submit.prevent="passes(save)">
      <v-card class="elevation-1 rounded-lg">
        <v-card-title class="pa-7">
          {{ title }}
        </v-card-title>
        <v-card-text class="pl-7 pr-7 pt-7">
          <v-row>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <CustomerAutocomplete
                v-if="!customer"
                v-model="value.customerId"
                :items="customers"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityWorkOrder.postalCode"
                rules="required"
                label="PSČ"
                outlined
                dense
                type="number"
                :loading="distributorLoading"
                background-color="white"
                @input="(event) => loadDistributor(event)"
              />
            </v-col>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VDatePickerWithValidation
                v-model="value.electricityWorkOrder.term"
                date-format="dd.MM.yyyy"
                rules="required"
                outlined
                dense
                label="Termín"
                :disabled="disabled"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="value.electricityWorkOrder.areaId"
                label="Objekt"
                rules="required"
                outlined
                dense
                background-color="white"
                :items="areas"
                item-text="name"
                item-value="id"
                :disabled="disabled"
              />
            </v-col>
            <v-col cols="12" sm="6" class="py-0 px-5">
              <VAutocompleteWithValidation
                v-model.trim="distributorType"
                label="Typ"
                outlined
                dense
                background-color="white"
                :items="distributorTypes"
                item-text="text"
                item-value="name"
                @change="() => distributorTypeChange()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-3 mt-3 mr-6 ml-6"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0 px-5">
              <v-radio-group v-model="value.electricityWorkOrder.typeIds" multiple row>
                <v-row v-if="distributorType === 'ELECTRICITY_WORK_OM_NEW'" class="">
                  <v-col v-for="item in types" :key="item.id" cols="12" md="6">
                    <v-radio
                      :label="item.name"
                      :value="item.id"
                      :checked="item.active"
                      :disabled="disabled"
                      @click="uncheckUsage(item)"
                    />
                  </v-col>
                </v-row>
                <v-card-title
                  v-if="distributorType === 'ELECTRICITY_WORK_OM_STANDING'"
                  style="font-size: large"
                  class="pa-0 pb-6"
                >
                  Drobné elektrikářské práce
                </v-card-title>
                <v-row v-if="distributorType === 'ELECTRICITY_WORK_OM_STANDING'" class="">
                  <v-col v-for="item in smallTypes" :key="item.id" cols="12" md="6">
                    <v-radio
                      :label="item.name"
                      :value="item.id"
                      :checked="item.active"
                      :disabled="disabled"
                      @click="uncheckUsage(item)"
                    />
                  </v-col>
                </v-row>
                <v-card-title
                  v-if="distributorType === 'ELECTRICITY_WORK_OM_STANDING'"
                  class="pa-0 pt-6 pb-6"
                  style="font-size: large"
                >
                  Větší elektrikářské práce
                </v-card-title>
                <v-row v-if="distributorType === 'ELECTRICITY_WORK_OM_STANDING'" class="">
                  <v-col v-for="item in largeTypes" :key="item.id" cols="12" md="6">
                    <v-radio
                      :label="item.name"
                      :value="item.id"
                      :checked="item.active"
                      :disabled="disabled"
                      @click="uncheckUsage(item)"
                    />
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0 px-5 pt-5">
              <VTextAreaWithValidation
                v-model.trim="value.electricityWorkOrder.content"
                label="Požadavek"
                outlined
                dense
                :disabled="disabled"
                background-color="white"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider class="mb-10 mt-3 mr-6 ml-6"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="py-0 px-5">
              <VTextFieldWithValidation
                v-model.trim="value.electricityWorkOrder.ean"
                label="EAN"
                outlined
                dense
                background-color="white"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-7">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            height="40px"
            min-width="130px"
            color="primary"
            depressed
            :disabled="disabled"
            :loading="saving"
          >
            Uložit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex'
import VDatePickerWithValidation from '@/components/validators/VDatePickerWithValidation'
import VTextAreaWithValidation from '../validators/VTextAreaWithValidation'
import VAutocompleteWithValidation from '../validators/VAutocompleteWithValidation'
import CustomerAutocomplete from './inputs/CustomerAutocomplete'

export default {
  name: 'OrderElectricityWorkForm',
  components: {
    CustomerAutocomplete,
    VAutocompleteWithValidation,
    VTextAreaWithValidation,
    VDatePickerWithValidation,
  },
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    edit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    saving: {
      type: Boolean,
      default: false,
      required: false,
    },
    customer: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      customers: [],
      distributor: {
        name: null,
      },
      distributorTypes: [
        {
          name: 'ELECTRICITY_WORK_OM_NEW',
          text: 'Nové odběrné místo',
        },
        {
          name: 'ELECTRICITY_WORK_OM_STANDING',
          text: 'Stávající odběrné místo',
        },
      ],
      distributorType: 'ELECTRICITY_WORK_OM_STANDING',
      distributorId: null,
      postalCode: null,
      areas: [],
      types: [],
      distributorLoading: false,
    }
  },
  computed: {
    disabled() {
      return this.distributor.name == null
    },
    smallTypes() {
      return this.types.filter((e) => e.kind === 'SMALL')
    },
    largeTypes() {
      return this.types.filter((e) => e.kind === 'LARGE')
    },
  },
  created() {
    this.loadElectricityWorkOrderTypes()
    this.loadElectricityWorkOrderAreas()
  },
  methods: {
    ...mapActions({
      getDistributor: 'electricity/getDistributorByType',
      getElectricityWorkOrderTypes: 'electricity/getElectricityWorkOrderTypes',
      getElectricityWorkOrderAreas: 'electricity/getElectricityWorkOrderAreas',
    }),
    loadDistributor(postalCode) {
      this.value.electricityWorkOrder.distributorId = null
      this.distributor = { name: null }
      if (postalCode.toString().length !== 5) {
        return
      }
      this.distributorLoading = true
      this.getDistributor({
        postalCode: postalCode,
        type: this.distributorType,
      })
        .then((response) => {
          this.distributor = response.data
          this.value.electricityWorkOrder.distributorId = response.data.id
        })
        .finally(() => {
          this.distributorLoading = false
        })
        .catch(() => {})
    },
    loadElectricityWorkOrderTypes() {
      this.getElectricityWorkOrderTypes({ type: this.distributorType }).then((response) => {
        this.types = response.data
      })
    },
    loadElectricityWorkOrderAreas() {
      this.getElectricityWorkOrderAreas({})
        .then((response) => {
          this.areas = response.data
        })
        .finally(() => {
          this.circuitBreakersLoading = false
        })
    },
    distributorTypeChange() {
      this.loadElectricityWorkOrderTypes()
      this.loadDistributor(this.value.electricityWorkOrder.postalCode)
    },
    uncheckUsage(item) {
      item.active = !item.active
      if (!item.active) {
        const removeIndex = this.value.electricityWorkOrder.typeIds
          .map(function (id) {
            return id
          })
          .indexOf(item.id)

        this.value.electricityWorkOrder.typeIds.splice(removeIndex, 1)
      }
    },
    save() {
      if (!this.value.electricityWorkOrder.typeIds) {
        this.value.electricityWorkOrder.typeIds = []
      }
      this.$emit('save', this.value)
    },
  },
}
</script>
